import { Routes, Route } from "react-router";
import SiteLayout from "./components/SiteLayout";
import HomePage from "./pages/HomePage";
import AproposPage from "./pages/AproposPage";
import QuiSommesNousPage from "./pages/QuiSommesNousPage";
import ProduitsPage from "./pages/ProduitsPage";
import ServicesPage from "./pages/ServicesPage";

export default function App() {
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="/a-propos" element={<AproposPage />} />
        <Route path="/qui-sommes-nous" element={<QuiSommesNousPage />} />
        <Route path="/produits" element={<ProduitsPage />} />
        <Route path="/services" element={<ServicesPage />} />
      </Route>
    </Routes>
  );
}